var map;
var markers = [];
var infoWindow;
let activePopup = null;


function resetMap(latitude, longitude, zoom){
    map = setupInitialMap(latitude, longitude, zoom);
    map.setOptions({ styles: getMapStyle() });
    markers.forEach(marker => marker.setMap(null));
    markers = [];

    // Create custom button
    const resetControlDiv = document.createElement("div");
    const resetControl = document.createElement("button");
    resetControl.textContent = "Reset Zoom";
    resetControl.style.margin = "10px";
    resetControl.classList.add("btn", "btn-primary");
    resetControl.style.padding = "6px";
    resetControl.style.fontSize = "10px";
    resetControl.style.cursor = "pointer";
    resetControlDiv.appendChild(resetControl);

    // Place it at bottom right
    map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(resetControlDiv);

    // Reset zoom on click
    resetControl.addEventListener("click", () => {
      map.setZoom($(window).width() <= 767 ? 1 : zoom || 3);
    });
}

function initMap(data) {   

    waitForGoogleMaps(() => {
    $(".js-spinner-map").hide();
    
    resetMap(data.latitude, data.longitude, data.zoomLevel);
    let hotelRoomData = data.items.filter((hotel) => hotel.room.isFeaturedRoom);
   
    const icon = {
        url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
          <svg width="32" height="32" viewBox="0 0 32 32" fill="#444" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 0C9.373 0 4 5.373 4 12c0 8.375 12 20 12 20s12-11.625 12-20c0-6.627-5.373-12-12-12zm0 16.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9z"/>
          </svg>
        `),
        scaledSize: new google.maps.Size(32, 32)
      };

    hotelRoomData.forEach(hotel => {

        var marker = new google.maps.Marker({
            position: { lat: hotel.lat, lng: hotel.long },
            map: map,
            title: hotel.name,
            category: "hotel",
            icon:icon
        });

        addMarkerEventListener(marker, hotel);
        marker.customId = hotel.id;
        markers.push(marker);

    })

    infoWindow = new google.maps.InfoWindow();
    
      new markerClusterer.MarkerClusterer({
        map,
        markers,
        renderer: {
            render: ({ markers, count, position }) => {
                const [r, g, b] = getDominantCategoryColor(markers);
              const svg = `
                <svg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="30" cy="30" r="22" fill="rgba(${r},${g},${b}, 0.2)" />
                  <circle cx="30" cy="30" r="18" fill="rgba(${r},${g},${b}, 0.3)" />
                  <circle cx="30" cy="30" r="14" fill="rgba(${r},${g},${b}, 0.85)" />
                  <text x="30" y="35" text-anchor="middle" fill="white" font-size="11" font-family="Arial" font-weight="bold">
                    ${count}
                  </text>
                </svg>
              `;
        
              return new google.maps.Marker({
                position,
                icon: {
                  url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
                  scaledSize: new google.maps.Size(60, 60),
                  anchor: new google.maps.Point(30, 30)
                },
                label: null
              });
            }
          }
      });

      map.addListener("click", () => {
        infoWindow.close();
      });

      google.maps.event.addListener(map, "zoom_changed", () => {
        console.log("Zoom changed to:", map.getZoom());
      });
    });

    
}

function initEmptyMap() {   

    waitForGoogleMaps(() => {
    $(".js-spinner-map").hide();
    
    resetMap(null,null,null);
    });
}



function setupInitialMap(latitude, longitude, zoom){
    return new google.maps.Map(document.getElementById('google-map'), {
        center: { lat: latitude || 8.234012, lng: longitude || 150.955021 },
        zoom: $(window).width() <= 767 ? 2 : zoom || 3,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        minZoom: $(window).width() <= 767 ? 2 : 3,
        maxZoom: 15,
        gestureHandling: "greedy",
    });
}

function initExperienceMap(expData) {   

    waitForGoogleMaps(() => {
    
        $(".js-spinner-map").hide();
    
        resetMap(expData.latitude, expData.longitude, expData.zoomLevel);

        const icon = {
            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
            <svg width="32" height="32" viewBox="0 0 32 32" fill="#8AC7DD" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 0C9.373 0 4 5.373 4 12c0 8.375 12 20 12 20s12-11.625 12-20c0-6.627-5.373-12-12-12zm0 16.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9z"/>
            </svg>
            `),
            scaledSize: new google.maps.Size(32, 32)
        };

        expData.items.forEach(experience => {

            var marker = new google.maps.Marker({
                position: { lat: experience.latitude, lng: experience.longitude },
                map: map,
                title: experience.name,
                category: "experience",
                icon:icon
            });

            addExperienceMarkerEventListener(marker, experience);
            marker.customId = experience.id;
            markers.push(marker);

        });
        infoWindow = new google.maps.InfoWindow();
        
        new markerClusterer.MarkerClusterer({
            map,
            markers,
            renderer: {
                render: ({ markers, count, position }) => {
                    const [r, g, b] = getDominantCategoryColor(markers);
                const svg = `
                    <svg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="30" cy="30" r="22" fill="rgba(${r},${g},${b}, 0.2)" />
                    <circle cx="30" cy="30" r="18" fill="rgba(${r},${g},${b}, 0.3)" />
                    <circle cx="30" cy="30" r="14" fill="rgba(${r},${g},${b}, 0.85)" />
                    <text x="30" y="35" text-anchor="middle" fill="white" font-size="11" font-family="Arial" font-weight="bold">
                        ${count}
                    </text>
                    </svg>
                `;
            
                return new google.maps.Marker({
                    position,
                    icon: {
                    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
                    scaledSize: new google.maps.Size(60, 60),
                    anchor: new google.maps.Point(30, 30)
                    },
                    label: null
                });
                }
            }
        });

        map.addListener("click", () => {
            infoWindow.close();
          });
    });
}

function waitForGoogleMaps(callback, maxAttempts = 20, interval = 100) {
    let attempts = 0;
  
    const check = () => {
      if (window.google && window.google.maps) {
        callback();
      } else if (attempts++ < maxAttempts) {
        setTimeout(check, interval);
      } else {
        console.error("Google Maps failed to load.");
      }
    };
  
    check();
}

function setupExperienceDetailsMap(lat,lng,name){

    waitForGoogleMaps(() => {

    var map = new google.maps.Map(document.getElementById('location-map'), {
        center: { lat: lat, lng: lng },
        zoom: 15,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false
    });


    var customStyle = getMapStyle(true);
            
                map.setOptions({ styles: customStyle });

                const icon = {
                    url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="#8AC7DD" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 0C9.373 0 4 5.373 4 12c0 8.375 12 20 12 20s12-11.625 12-20c0-6.627-5.373-12-12-12zm0 16.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9z"/>
                      </svg>
                    `),
                    scaledSize: new google.maps.Size(32, 32)
                  };
                
                var url = "https://www.google.com/maps/search/?q=" + name + "," + lat + "," + lng;
                var marker = new google.maps.Marker({
                    position: { lat: lat, lng: lng },
                    map: map,
                    title: name,
                    url : url,
                    icon:icon
                });

                google.maps.event.addListener(marker, 'click', function() { 
                    window.open(this.url, '_blank');
                });
    });
}

function getColorByCategory(markers){
    const categories = markers.map(m => m.category);
    if (categories.includes("hotel")) return [68, 68, 68];
    if (categories.includes("experience")) return [138, 199, 221];
    return [0, 0, 255];
  };

  function getDominantCategoryColor(markers) {
    const counts = {};
  
    for (const m of markers) {
      const cat = m.category || 'unknown';
      counts[cat] = (counts[cat] || 0) + 1;
    }
  
    // Get the most frequent category
    const [dominantCategory] = Object.entries(counts).sort((a, b) => b[1] - a[1])[0];
  
    // Map to RGB
    const colorMap = {
      hotel: [68, 68, 68],
      experience: [138, 199, 221],
      unknown: [0, 0, 255]
    };
  
    return colorMap[dominantCategory] || colorMap['unknown'];
  };

function initializeMapCarousel() {

    const hotelContainers = document.querySelectorAll(".suite-container");

    hotelContainers.forEach(item => {
        let currentIndex = 0;
        const images = $(item).find('.img-container img');
        const totalImages = images.length;

        function showImage(index) {
            images.removeClass('active');
            images.eq(index).addClass('active');
        }

        /*$(item).find('.left-btn').click(function () {
            currentIndex = (currentIndex > 0) ? currentIndex - 1 : totalImages - 1;
            showImage(currentIndex);
        });

        $(item).find('.right-btn').click(function () {
            currentIndex = (currentIndex < totalImages - 1) ? currentIndex + 1 : 0;
            showImage(currentIndex);
        });*/
    })
}



function addMarkerEventListener(marker, hotel) 
{
    marker.addListener('click', function() {
        infoWindow.setContent(
            mountMarkerContainer(hotel)
        );
        getHotelRoomPrice(hotel.hotelId, hotel.room.roomId)

        infoWindow.addListener('domready', () => {
            setupTileSliders();
          });

        infoWindow.open(map, marker);

    });
}




function addExperienceMarkerEventListener(marker, experience) 
{
    marker.addListener('click', function() {
        infoWindow.setContent(
            mountExperienceMarkerContainer(experience)
        );

        infoWindow.addListener('domready', () => {
            setupTileSliders();
          });
        infoWindow.open(map, marker);
    });
}

function getHotelRoomPrice(hotelId, roomId){
    let searchData = getSearchFilters();
    let filteredData = {
        checkInDate : searchData.checkInDate,
        checkOutDate : searchData.checkOutDate,
        adultsMin: searchData.adultsMin,
        childMin:  searchData.childMin,
        featuredOnly: true,
        hotelId: hotelId,
        roomId: roomId,
        orderById: 7
    };   
    getHotels(filteredData)
        .done(function (data) 
        {
            if(data.items.length > 0)
            {
                $("span.js-price-loading-" + roomId).text(data.items[0].room.priceString);
            }
        })
        .fail(function(jqXHR, textStatus,errorThrown)
        {
            console.error("Error occurred:", textStatus, errorThrown);
        })
}

function mountMarkerContainer(hotel){

    let hotelContainer = document.createElement('div');
    let componentToMount = '';
    let imageHtml = generateHotelRoomImageMarkup(hotel);

    componentToMount = `<div class="suite-container floating">
            <div class="info-container floating">
            <div class="img-container slider">
            <div class="splide normal">
                <div class="splide__track">
                    <ul class="splide__list">
                                ${imageHtml}
                     </ul>
                    </div>
                    </div>
            </div>
                <div class="wrapper">
                    
                    <div class="hotel-location">
                        <div class="location">
                            <img src="../images/icons/location-icon.svg" width="10"/><a href="${hotel.url}">${hotel.shortAddress}</a>
                        </div>
                        <div class="price">
                            <span class="loading js-price-loading-${hotel.room.roomId}" style="display: flex; js-price"><img width="30" src="/images/icons/spinner-diamonds.gif" alt="loading..."></span>
                        </div>
                    </div>
                    <div class="hotel-name">
                        <div class="name">
                           <a href="${hotel.url}">${hotel.room.name}</a>
                        </div>
                    </div>
                    <div class="hotel-subtitle-cont">
                    <div class="hotel-subtitle">
                    ${hotel.name}
                    </div>
                   </div>
                    <div class="hotel-info-list" style="font-size: 1.2em;">
                    <div class="hotel-info-list" style="font-size: 1.2em;">
                        <div class="button-wrapper" style="gap: 5px;">
                        ${hotel.multiple ? ' <a class="btn outline" href="'+hotel.listingUrl+'">VIEW ALL SUITES</a>' : ''}
                        <a class="btn btn-primary explore" href="${hotel.url}">RESERVE</a>
                    </div>
                            
                </div>
                </div>
            </div>
            
        </div>`

    hotelContainer.innerHTML = componentToMount;
    return hotelContainer;

}

function mountExperienceMarkerContainer(experience){

    let experienceContainer = document.createElement('div');
    let componentToMount = '';
    let imageHtml = generateExperienceImageMarkup(experience);

    componentToMount = `<div class="suite-container floating">
            <div class="info-container floating">
            <div class="info-container floating">
            <div class="img-container slider">
            <div class="splide normal">
                <div class="splide__track">
                    <ul class="splide__list">
                                ${imageHtml}
                     </ul>
                    </div>
                    </div>
            </div>
                <div class="wrapper">
                    
                    <div class="hotel-location">
                        <div class="location">
                            <img src="../images/icons/location-icon.svg" width="10"/><a href="${experience.detailsUrl}">${experience.city}, ${experience.country}</a>
                        </div>
                    </div>
                    <div class="hotel-name">
                        <div class="name experience-name"><a href="${experience.detailsUrl}">${experience.name}</a></div>
                    </div>
                    <div class="hotel-subtitle-cont">
                    <div class="hotel-subtitle">${experience.subTitle}</div>
                   </div>
                    <div class="hotel-info-list" style="font-size: 1.2em;">
                    <div class="hotel-info-list" style="font-size: 1.2em;">
                        <div class="button-wrapper" style="gap: 5px;">
                        <a class="btn btn-primary explore" href="${experience.detailsUrl}">EXPLORE</a>
                    </div>
                            
                </div>
                </div>
            </div>
            
        </div>`

    experienceContainer.innerHTML = componentToMount;
    return experienceContainer;

}

function getMapStyle(showCity = true){
    return [
        {
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#D4D2C7"
                }
            ]
        },
        {
            "featureType":"all",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative.country",
            "elementType": "labels",
            "stylers": [
                { "visibility": "on" }
            ]
        },
        {
            "featureType": "administrative.country",
            "elementType": "geometry",
            "stylers": [
                { 
                    "visibility": "on" 
                }, 
                { 
                    "color": "#cccccc" 
                }
            ]
        },
        {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#000000" }, { visibility: showCity ? "on" : "off" }],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.stroke",
            stylers: [{ visibility: showCity ? "on" : "off" }],
          },
        {
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#616161"
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#f5f5f5"
                }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#bdbdbd"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e5e5e5"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#dadada"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#616161"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e5e5e5"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f7f2eb" // Cor para �gua
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        }
    ];
}